import { Users } from 'lucide-react';
import { Card } from '../ui/Card';
import type { Employee } from '@/types/tycoon';
import { employeeService, EMPLOYEE_ROLE_ORDER, getRoleDisplayName } from '@/services/tycoon/employeeService';
import { formatCurrency } from '@smartphone-tycoon/shared-ui';

interface EmployeeStatsCardProps {
  employees: Employee[];
  onClick?: () => void;
  className?: string;
}

export function EmployeeStatsCard({
  employees,
  onClick,
  className = ''
}: EmployeeStatsCardProps) {
  const stats = employeeService.getEmployeeStats(employees);
  const totalSalary = employeeService.calculateDailySalaryCosts(employees);

  return (
    <Card 
      className={`p-6 ${onClick ? 'cursor-pointer hover:shadow-lg transition-shadow' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-5 h-5 text-theme-info" />
        <h3 className="text-xl font-semibold text-theme-text-primary">Employees</h3>
      </div>
      
      <div className="space-y-3">
        {EMPLOYEE_ROLE_ORDER.map(role => (
          <div key={role} className="flex justify-between items-center py-2 border-b border-theme-border">
            <span className="text-theme-text-secondary">{getRoleDisplayName(role)}s</span>
            <span className="font-semibold text-lg" data-testid={`employee-count-${role}`}>{stats[role]}</span>
          </div>
        ))}
        <div className="mt-4 pt-4 border-t border-theme-border">
          <div className="flex justify-between items-center">
            <span className="text-theme-text-secondary font-medium">Total Employees</span>
            <span className="font-bold text-xl text-theme-info">{stats.total}</span>
          </div>
          <div className="flex justify-between items-center mt-2">
            <span className="text-theme-text-secondary text-sm">Daily Salary Cost</span>
            <span className="font-medium text-sm">{formatCurrency(totalSalary)}</span>
          </div>
        </div>
      </div>
    </Card>
  );
}